export default function wc_cart_page() {
  const classlist = [];
  $('.cart-page-wrapper .variation dt').each(function() {
    classlist.push($(this).attr('class'));
  });

  classlist.forEach((variationClass) => {
    $('.cart-page-wrapper .' + variationClass).wrapAll('<div class="single-variation"></div>');
  });
}
